import ReactApexChart from 'react-apexcharts';
import { ColorRing } from 'react-loader-spinner';

import { HubTrapsChartOptions } from './HubTrapsChartOptions';

import { HubDetailPageApiResponse } from 'api/traps/Hubs/types';

interface HubTrapsChartProps {
  slug: string;
  isLoading: boolean;
  data?: HubDetailPageApiResponse | null;
}

const HubTrapsChart = ({ slug, data, isLoading }: HubTrapsChartProps) => {
  const { options } = HubTrapsChartOptions({ data: data || undefined });
  if (isLoading || !data) {
    return (
      <div className="card d-flex m-0 shadow-lg">
        <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '350px' }}>
          <ColorRing
            visible
            height="80"
            width="80"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="card-body">
      <ReactApexChart key={slug} options={options} series={options.series} type="donut" height={380} />
    </div>
  );
};

export default HubTrapsChart;
